/**
 * Client-facing Booking ID (KH-xxxxxx). Same code labels everywhere (invoice, tracker, admin).
 * Derived from the Firestore document id segment after the last underscore.
 */

export function getBookingShortKey(fullDocumentId) {
  const id = fullDocumentId && String(fullDocumentId).trim();
  if (!id) return '';
  const suffix = id.includes('_') ? id.split('_').pop() || '' : id;
  const tail = suffix.slice(-6);
  return tail ? tail.toLowerCase() : '';
}

/** Display ref e.g. KH-9dibto (normalized lowercase tail). */
export function formatBookingShortId(fullDocumentId) {
  const key = getBookingShortKey(fullDocumentId);
  return key ? `KH-${key}` : '';
}
